export default __webpack_public_path__ + "static/media/departments.1229874f.jpg";